import React from "react"
import Footer from "../components/Footer/Footer"
import Navbar from "../components/Navbar/Navbar"
import Seo from "../components/Seo"

export default function CookiePolicy() {
  return (
    <React.Fragment>
      <Seo title={"Cookie Policy"} />
      <Navbar />
      <main className="marginTopNavbar">
        <div className="main-container">
          <section className="overview">
            <div className="grid-8-col">
              <div className="col-3">
                <h1 className="sticky">Cookie Policy</h1>
              </div>

              <div className="col-4" style={{ minWidth: 0 }}>

                <h2>What are cookies?</h2>
                <br />
                <p>
                  A cookie is a small file containing alphanumeric information
                  stored by the browser in local device storage when accessing a
                  website. The Advanced Therapies Group website uses cookies to
                  improve browsing experience, eliminate repetitive data entry,
                  and increase response efficiency.
                </p>
                <br />
                <p>
                  Portuguese law implements the European e-Privacy Directive
                  through Law No. 41/2004 (amended by Law No. 46/2012) on
                  "Protection of personal data and privacy in
                  telecommunications," requiring informed consent before storing
                  information on user devices.
                </p>
                <br />
                <br />

                <h2>Cookies – Data Controller</h2>
                <br />
                <p>
                  Cookies are classified by ownership:
                </p>
                <br />
                <p>
                  <strong>First-party cookies</strong> — Processed by the
                  entity responsible for the website domain.
                </p>
                <br />
                <p>
                  <strong>Third-party cookies</strong> — Processed by entities
                  other than the website owner. The only third-party cookies on
                  this website come from embedded YouTube videos, which set
                  their own cookies subject to Google's privacy policy, and
                  only after you have given your consent.
                </p>
                <br />
                <br />

                <h2>Cookies – Duration</h2>
                <br />
                <p>
                  <strong>Session cookies</strong> — Active only during one
                  browsing session and automatically deleted when the browser
                  closes.
                </p>
                <br />
                <p>
                  <strong>Persistent cookies</strong> — Remain on your device
                  for a specified period or until manually deleted. They collect
                  information across sessions to remember preferences and
                  measure usage.
                </p>
                <br />
                <br />

                <h2>Cookies – Purpose</h2>
                <br />
                <p>
                  <strong>Essential cookies</strong> — Necessary for the
                  website to function correctly. These cannot be disabled
                  without affecting core functionality.
                </p>
                <br />
                <p>
                  <strong>Analytical and marketing cookies</strong> — Collect
                  statistical information about website usage or track users
                  for advertising purposes. <strong>This website does not use
                  analytical or marketing cookies.</strong>
                </p>
                <br />
                <p>
                  <strong>Multimedia cookies</strong> — Set by embedded video
                  players (YouTube) to enable playback and remember preferences.
                  These are subject to YouTube's own cookie policy.
                </p>
                <br />
                <br />

                <h2>Cookies Used</h2>
                <br />
                <p>
                  This website itself does not set any cookies. The only
                  cookies that may be set when you visit are third-party
                  cookies from embedded YouTube videos, listed below.
                </p>
                <br />

                <p><strong>Multimedia (YouTube)</strong></p>
                <br />
                <p>
                  Some pages on our site embed video content hosted on YouTube
                  (served through YouTube's privacy-enhanced domain,
                  youtube-nocookie.com). These videos are only loaded after you
                  accept cookies via the consent banner; if you decline, they
                  are not embedded and no third-party cookies are set. When you
                  play a video, YouTube may set its own cookies on your device.
                  These cookies are subject to YouTube's privacy policy,
                  available at{" "}
                  <a
                    href="https://policies.google.com/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    policies.google.com/privacy
                  </a>
                  .
                </p>
                <br />

                <div style={{ overflowX: "auto" }}>
                <table style={{ borderCollapse: "collapse", fontSize: "0.875rem", minWidth: "100%" }}>
                  <thead>
                    <tr style={{ borderBottom: "1px solid black" }}>
                      <th style={{ textAlign: "left", padding: "8px 16px 8px 0", fontFamily: "inherit", whiteSpace: "nowrap" }}>Name</th>
                      <th style={{ textAlign: "left", padding: "8px 16px 8px 0", fontFamily: "inherit", whiteSpace: "nowrap" }}>Duration</th>
                      <th style={{ textAlign: "left", padding: "8px 16px 8px 0", fontFamily: "inherit", whiteSpace: "nowrap" }}>Type</th>
                      <th style={{ textAlign: "left", padding: "8px 0", fontFamily: "inherit" }}>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      ["__Secure-1PAPISID", "Persistent", "Advertising (Google)","User profile building for personalised Google advertising."],
                      ["__Secure-1PSID", "Persistent", "Advertising (Google)","User profile creation for personalised Google advertising."],
                      ["__Secure-1PSIDCC", "Session", "Advertising (Google)","User profile identification for personalised Google advertising."],
                      ["__Secure-1PSIDTS", "Persistent", "Advertising (Google)","User authentication and session preference storage."],
                      ["__Secure-3PAPISID", "Persistent", "Advertising (Google)","User profile creation for personalised Google advertising."],
                      ["__Secure-3PSID", "Persistent", "Advertising (Google)","User profile creation for personalised Google advertising."],
                      ["__Secure-3PSIDCC", "Persistent", "Advertising (Google)","User profile creation for personalised Google advertising."],
                      ["__Secure-3PSIDTS", "Persistent", "Advertising (Google)","User profile creation for personalised Google advertising."],
                      ["__Secure-BUCKET", "Persistent", "Essential", "Tests whether the browser supports cookies."],
                      ["__Secure-ENID", "Persistent", "Essential", "Stores encrypted user identity information for Google services."],
                      ["__Secure-ROLLOUT_TOKEN", "Persistent", "Essential", "Used for gradual feature rollout tracking across Google services."],
                      ["__Secure-STRP", "Persistent", "Essential", "Google session cookie for security and fraud prevention."],
                      ["__Secure-YEC", "Persistent", "Multimedia", "YouTube encrypted cookie for user session management."],
                      ["__Secure-YENID", "Persistent", "Multimedia", "YouTube encrypted user identifier."],
                      ["__Secure-YNID", "Persistent", "Multimedia", "YouTube user identifier for session management."],
                      ["AEC", "Persistent", "Essential", "Session request verification ensuring the user is authorised."],
                      ["APISID", "Persistent", "Advertising (Google)","YouTube embedded video playback and Google Maps integration."],
                      ["DV", "Session", "Advertising (Google)","Personalised advertisement delivery service."],
                      ["HSID", "Persistent", "Essential", "Fraud prevention service using digitally signed Google account records."],
                      ["LOGIN_INFO", "Persistent", "Multimedia", "Stores login preferences for YouTube."],
                      ["NID", "Persistent", "Advertising (Google)","Stores user preferences for Google services (e.g. language, safe search)."],
                      ["PREF", "Persistent", "Multimedia", "Stores user preferences such as page size and autoplay settings."],
                      ["SAPISID", "Persistent", "Essential", "User preference storage including language and browser preferences."],
                      ["SEARCH_SAMESITE", "Persistent", "Essential", "Prevents cross-website cookie transmission (SameSite enforcement)."],
                      ["SID", "Persistent", "Multimedia", "YouTube embedded video playback service."],
                      ["SIDCC", "Session", "Essential", "Security cookie used to protect user data from unauthorised access."],
                      ["SSID", "Persistent", "Advertising (Google)","Digitally signed and encrypted user Google account records."],
                      ["test_cookie", "Session", "Essential", "Tests whether the browser supports cookies."],
                      ["VISITOR_INFO1_LIVE", "6 months", "Multimedia", "Estimates bandwidth to determine whether to serve the old or new player interface."],
                      ["VISITOR_PRIVACY_METADATA", "6 months", "Multimedia", "Stores the user's cookie consent status for the current domain."],
                      ["YSC", "Session", "Multimedia", "Registers a unique ID to keep statistics of videos watched on YouTube."],
                    ].map(([name, duration, type, desc]) => (
                      <tr key={name} style={{ borderBottom: "1px solid #e0e0e0" }}>
                        <td style={{ padding: "8px 16px 8px 0", whiteSpace: "nowrap" }}>{name}</td>
                        <td style={{ padding: "8px 16px 8px 0", whiteSpace: "nowrap" }}>{duration}</td>
                        <td style={{ padding: "8px 16px 8px 0", whiteSpace: "nowrap" }}>{type}</td>
                        <td style={{ padding: "8px 0" }}>{desc}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                </div>
                <br />
                <br />

                <h2>Cookies Exempt from Consent</h2>
                <br />
                <p>
                  Cookies that are strictly necessary for the website to
                  function do not require prior consent. These include session
                  cookies used to maintain basic navigation and any cookies
                  essential to an expressly requested service.
                </p>
                <br />
                <br />

                <h2>How to Manage Cookies</h2>
                <br />
                <p>
                  You can change your consent choice at any time via the
                  "Cookie Preferences" link in the website footer. Withdrawing
                  consent is as easy as giving it: if you decline, embedded
                  videos are removed and cookies previously set on this domain
                  are deleted.
                </p>
                <br />
                <p>
                  You can also control and/or delete cookies directly in your
                  browser. You can
                  delete all cookies already on your device and set most
                  browsers to prevent them from being placed. If you do this,
                  however, you may have to manually adjust some preferences
                  every time you visit our site, and some services and
                  functionalities may not work.
                </p>
                <br />
                <p>Find out how to manage cookies in your browser:</p>
                <br />
                <p>
                  <a
                    href="https://support.google.com/chrome/answer/95647"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Google Chrome
                  </a>
                </p>
                <p>
                  <a
                    href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Mozilla Firefox
                  </a>
                </p>
                <p>
                  <a
                    href="https://support.apple.com/en-gb/guide/safari/sfri11471/mac"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Safari
                  </a>
                </p>
                <p>
                  <a
                    href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Microsoft Edge
                  </a>
                </p>
                <br />
                <br />

                <h2>Contact</h2>
                <br />
                <p>
                  If you have any questions about our use of cookies or this
                  Cookie Policy, please contact us at{" "}
                  <a href="mailto:lino.ferreira@uc.pt">lino.ferreira@uc.pt</a>.
                </p>
                <br />
                <p style={{ fontSize: "0.875rem", color: "#666" }}>
                  Last revised: July 2026
                </p>
                <br />
                <br />
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </React.Fragment>
  )
}
